import React from "react";
import { EmployeeRegistartionContextProvider } from "./EmployeeRegistartionView";
import EmployeeRegistration from "./view/EmployeeRegistration";
import EmployeeRegistrationContent from "../../constants/contentFile.json";
const EmployeeRegistartionPage = () => {
  return (
    <EmployeeRegistartionContextProvider>
      <EmployeeRegistration
        textContants={EmployeeRegistrationContent.employeeRegistrationPage}
      />
    </EmployeeRegistartionContextProvider>
  );
};

export default EmployeeRegistartionPage;
